<template>
  <b-form-group id="fontSize" horizontal label-cols="3" label-size="md" :label="$t('labels.fontSize') + ':'">
    <b-row>
      <b-col lg="5">
        <label for="Compact" class="customi_label">
          <input type="radio" id="Compact" name="size" value="Compact" class="invisible customi_input" v-model="size">
          <div class="customi_div radio">
            <svg class="customi_svg" version="1.1" id="Layer_1" viewBox="0 0 20 20">
              <circle class="svg_bg" cx="10" cy="10" r="9"/>
              <circle class="svg_top radio_check" cx="10" cy="10" r="6"/>
            </svg>
          </div>
          <span>{{ $t("labels.compact")}}</span>
        </label>
      </b-col>
      <b-col lg="5">
        <label for="Big" class="customi_label">
          <input type="radio" id="Big" name="size" value="Big" class="invisible customi_input" v-model="size">
          <div class="customi_div radio">
            <svg class="customi_svg" version="1.1" id="Layer_1" viewBox="0 0 20 20">
              <circle class="svg_bg" cx="10" cy="10" r="9"/>
              <circle class="svg_top radio_check" cx="10" cy="10" r="6"/>
            </svg>
          </div>
          <span>{{ $t("labels.big")}}</span>
        </label>
      </b-col>
    </b-row>
  </b-form-group>
</template>

<script>
export default {
  name: 'fontSize',
  data () {
    return {
      size: localStorage.getItem('size') ? localStorage.getItem('size') : 'Compact',
      checked: true
    };
  },
  watch: {
    size (val) {
      localStorage.setItem('size', val);
      this.$parent.$parent.$parent.updateUIAfterThemeChanged();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/Settings/fontSize.vue